import { AntDesign } from "@expo/vector-icons";
import { Box, HStack, Icon, IconButton, Text, TextArea, VStack, useTheme } from "native-base";
import React, { useState } from "react";
import StarRating from "react-native-star-rating-widget";

import FormButton from "@/components/atoms/FormButton";

import { DeliveryEvaluationData, OrdeEvaluationComponentProps } from "../types";

const DeliveryEvaluationStep = ({
  onSubmit,
  onCancel,
}: OrdeEvaluationComponentProps<DeliveryEvaluationData>) => {
  const [rating, setRating] = useState(0);
  const [deliveryStatus, setDeliveryStatus] = useState<"delivered" | "not-delivered">("delivered");

  const { colors } = useTheme();

  return (
    <VStack>
      <VStack my="2" space={2} alignItems="center">
        <Text fontSize="lg" color="primary.600">
          Como foi sua experiência com a entrega?
        </Text>
        <Text color="gray.400" textAlign="center">
          Avalie, com base na quantidade de estrelas, a sua satisfação com a entrega
        </Text>
      </VStack>
      <Box my="4" alignItems="center">
        <StarRating
          rating={rating}
          color={colors.primary["600"]}
          starSize={46}
          enableHalfStar={false}
          onChange={setRating}
        />
      </Box>
      <VStack my="4">
        <Text color="gray.400" my="2" alignSelf="center">
          O seu pedido chegou no tempo estimado de entrega?
        </Text>
        <HStack py="2" justifyContent="space-around">
          <Box alignItems="center">
            <IconButton
              w="64px"
              h="64px"
              key={deliveryStatus}
              icon={<Icon size="3xl" as={AntDesign} name="like2" />}
              borderColor="primary.600"
              borderRadius="full"
              borderWidth="1"
              bg={deliveryStatus === "delivered" ? "secondary.400" : "white"}
              onPress={() => setDeliveryStatus("delivered")}
            />
            <Text>Sim, chegou</Text>
          </Box>
          <Box alignItems="center">
            <IconButton
              w="64px"
              h="64px"
              key={deliveryStatus}
              icon={<Icon size="3xl" as={AntDesign} name="dislike2" />}
              borderColor="primary.600"
              borderRadius="full"
              borderWidth="1"
              bg={deliveryStatus === "not-delivered" ? "secondary.400" : "white"}
              onPress={() => setDeliveryStatus("not-delivered")}
            />
            <Text>Não, não chegou</Text>
          </Box>
        </HStack>
      </VStack>
      <HStack my="6" justifyContent="space-between">
        <FormButton
          width="40%"
          colorScheme="white"
          textColor="primary.700"
          shadow="2"
          onPress={() => onCancel()}>
          Voltar
        </FormButton>
        <FormButton
          isDisabled={!rating}
          width="40%"
          onPress={() =>
            onSubmit({
              rate: rating,
              delivered: deliveryStatus === "delivered",
            })
          }>
          Próximo
        </FormButton>
      </HStack>
    </VStack>
  );
};

export default DeliveryEvaluationStep;
